<template>
  <div class="row">
    <div class="col-md-4">
      <!-- general form elements -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">{{ msg }}</h3>
        </div>
      </div>

      <div class="box-body">
        <div class="form-group">
          <label for="">Fiscale waarde</label>
          <input
            type="number"
            name=""
            value=""
            v-model="calculator.fiscalValue"
            placeholder="Vul hier de fiscale waarde in"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="">Privé km's per jaar</label>
          <div class="">
            <input
              type="radio"
              id="499"
              value="499"
              v-model="calculator.privateKmYear"
            />
            <label for="499" class="label-body">0 tot 500 km</label>
            <input
              type="radio"
              id="500"
              value="500"
              v-model="calculator.privateKmYear"
            />
            <label for="500" class="label-body">meer dan 500 km</label>
          </div>
        </div>

        <div class="form-group">
          <label for="">Loonheffingskorting</label>
          <input
            type="checkbox"
            name=""
            value=""
            v-model="calculator.loonheffingskorting"
            class="form-control mw-15"
          />
        </div>

        <div class="form-group" v-if="taxRates != null">
          <label for="">Fiscaal inkomen per jaar</label>
          <select v-model="calculator.taxRate" class="form-control">
            <option
              v-for="(t, index) in taxRates"
              v-bind:value="t.nPercentage"
              v-bind:selected="index === 0"
            >
              &euro; {{ t.nBelastbaarVan | CurrencyWithoutCents }},-
              <span v-if="t.nBelastbaarTot == 999999"> en meer </span>
              <span v-else
                >tot en met &euro;
                {{ t.nBelastbaarTot | CurrencyWithoutCents }},-</span
              >
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="">Datum kenteken afgifte auto(Bijtellingsjaar)</label>
          <select
            v-model="additionYear"
            class="form-control"
            @change="getBijtelling(additionYear)"
          >
            <option
              v-for="(y, index) in additionYears"
              v-bind:value="y.y"
              v-bind:selected="y.y === new Date().getFullYear()"
            >
              {{ y.y }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="">Bijtellingspercentage</label>
          <div class="">
            <span v-for="a in additionRates">
              <input
                type="radio"
                id="4"
                :value="a.nProcent"
                v-model="calculator.additionRate"
              />
              <label :for="a.nProcent" class="label-body"
                >{{ a.nProcent }}%</label
              >
            </span>
          </div>
        </div>

        <div class="form-group">
          <label for="">Eigen bijdrage</label>
          <input
            type="number"
            name=""
            value=""
            v-model="calculator.contribution"
            placeholder="Eigen bijdrage"
            class="form-control"
          />
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <!-- general form elements -->
      <div class="box" style="margin-left: 25px">
        <div class="box-header with-border">
          <h3 class="box-title">Kosten per maand</h3>
        </div>
      </div>
      <div class="box-body" style="margin-left: 25px">
        <h4>&euro; {{ montlyPrice | currency }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calculator",
  data() {
    return {
      msg: "Bijtelling berekenen",
      taxRates: null,
      additionYears: [],
      additionYear: "",
      additionRates: [],
      calculator: {
        privateKmYear: "",
        fiscalValue: "",
        taxRate: "",
        additionRate: "",
        contribution: 0,
        loonheffingskorting: false,
      },
      montlyPrice: 0,
    };
  },
  watch: {
    calculator: {
      handler(obj) {
        this.updateMontlyPrice();
      },
      deep: true,
    },
    "calculator.loonheffingskorting": function () {
      this.calculator.taxRate = "";
      this.taxRates = null;
      this.getBelasting();
    },
  },
  filters: {
    CurrencyWithoutCents: function (value) {
      if (value == undefined) return;
      return value
        .toString()
        .replace(/,/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  created: function () {
    this.calculator.privateKmYear = 500;
    this.getBelasting();

    let date = new Date().getFullYear();
    this.additionYears.push({ y: date - 5 });
    this.additionYears.push({ y: date - 4 });
    this.additionYears.push({ y: date - 3 });
    this.additionYears.push({ y: date - 2 });
    this.additionYears.push({ y: date - 1 });
    this.additionYears.push({ y: date });
    this.additionYears.push({ y: date + 1 });
    this.additionYears.push({ y: date + 2 });
    this.additionYear =
      new Date().getMonth() == 11
        ? new Date().getFullYear() + 1
        : new Date().getFullYear();

    this.getBijtelling(this.additionYear);
  },
  methods: {
    updateMontlyPrice: function () {
      let contribution = this.calculator.contribution;
      if (
        this.calculator.contribution == "" ||
        this.calculator.contribution == null
      )
        contribution = 0;

      if (this.calculator.privateKmYear < 500) {
        this.montlyPrice = this.calculator.contribution;
      } else {
        // bijtelling 2019
        if (this.additionYear == 2019 && this.calculator.additionRate == 4) {
          if (parseInt(this.calculator.fiscalValue) > 50000) {
            this.montlyPrice =
              ((50000 * (this.calculator.additionRate / 100) +
                (this.calculator.fiscalValue - 50000) * (22 / 100) -
                parseInt(contribution) * 12) *
                (this.calculator.taxRate / 100)) /
                12 +
              parseInt(contribution);
          } else {
            this.montlyPrice =
              ((this.calculator.fiscalValue *
                (this.calculator.additionRate / 100) -
                parseInt(contribution) * 12) *
                (this.calculator.taxRate / 100)) /
                12 +
              parseInt(contribution);
          }
        } else if (
          this.additionYear > 2019 &&
          this.calculator.additionRate < 22
        ) {
          //bijtelling nieuwe releging 2020
          let benefitLimit = this.getEvBeneFitLimit(this.additionYear);
          // let benefitLimit = 35000;
          // if (this.additionYear == 2020) benefitLimit = 45000;

          if (parseInt(this.calculator.fiscalValue) > benefitLimit) {
            this.montlyPrice =
              ((benefitLimit * (this.calculator.additionRate / 100) +
                (this.calculator.fiscalValue - benefitLimit) * (22 / 100) -
                parseInt(contribution) * 12) *
                (this.calculator.taxRate / 100)) /
                12 +
              parseInt(contribution);
          } else {
            this.montlyPrice =
              ((this.calculator.fiscalValue *
                (this.calculator.additionRate / 100) -
                parseInt(contribution) * 12) *
                (this.calculator.taxRate / 100)) /
                12 +
              parseInt(contribution);
          }
        } else {
          this.montlyPrice =
            ((parseInt(this.calculator.fiscalValue) *
              (parseInt(this.calculator.additionRate) / 100) -
              12 * parseInt(contribution)) *
              (this.calculator.taxRate / 100)) /
              12 +
            parseInt(contribution);
        }
      }
    },
    getBelasting: function () {
      let name = "getBelastingschijven";
      if (this.calculator.loonheffingskorting)
        name = "getBelastingschijvenMetLoonheffingskorting";
      //getBelastingschijvenMetLoonheffingskorting
      this.$http
        .get(
          process.env.API_URL_AUTO +
            name +
            "/cClient=6ef14228-8346-422c-9dc0-4af9bae0092b"
        )
        .then((response) => {
          let result = "getBelastingschijvenResult";
          if (this.calculator.loonheffingskorting)
            result = "getBelastingschijvenMetLoonheffingskortingResult";
          this.taxRates = response.body[result];
          //this.taxRates = response.body.getBelastingschijvenResult
          this.calculator.taxRate = this.taxRates[0].nPercentage;
        });
    },
    getBijtelling: function (date) {
      this.additionRates = [];
      this.$http
        .get(
          process.env.API_URL_AUTO +
            "getBijtellingen/cClient=6ef14228-8346-422c-9dc0-4af9bae0092b;nJaar=" +
            date
        )
        .then((response) => {
          console.log(response);
          for (let i in response.body.getBijtellingenResult) {
            // @dennis - check why this is not the last commit

            // if (response.body.getBijtellingenResult[i].cBrandstof == "l") {
            this.additionRates.push(response.body.getBijtellingenResult[i]);
            this.calculator.additionRate =
              this.additionRates[this.additionRates.length - 1].nProcent;
          }
          // }
        });
    },

    getEvBeneFitLimit: function (year) {
      switch (year) {
        case 2019:
          return 50000;
        case 2020:
          return 45000;
        case 2021:
          return 40000;
        case 2022:
          return 35000;
        case 2023:
          return 30000;
        case 2024:
          return 30000;
        case 2025:
          return 30000;
        case 2026:
          return 0;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-group {
  margin-bottom: 15px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.mw-15 {
  max-width: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Calculator.vue